import React, { useState, useEffect } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Catalog',
  href: '#catalog'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Authors',
  href: '#authors'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-ink/95 backdrop-blur border-b border-white/10' : 'bg-transparent'}`} data-id="element-145" data-mp="ejnzuv2khkup">
      <nav className="mx-auto max-w-6xl px-6 h-20 flex items-center justify-between" data-id="element-146" data-mp="1pxrum3gzbd0t">
        <a href="#top" className="flex flex-col leading-none" data-id="element-147" data-mp="1kzzqmb3280g9">
          <span className="font-serif text-2xl text-paper tracking-wide" data-id="element-148" data-mp="1l1kkdyhjvfd2">Deleon</span>
          <span className="text-[0.6rem] uppercase tracking-[0.35em] text-gold-light" data-id="element-149" data-mp="9o7tvx7bnala">
            Publishing LLC
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-9" data-id="element-150" data-mp="jmx2t0h8pkpe">
          {links.map(l => <li key={l.href} data-id="element-151" data-mp="olgoczrx8uh8">
              <a href={l.href} className="text-sm text-paper/80 hover:text-gold-light transition-colors tracking-wide" data-id="element-152" data-mp="okp3aivyaf57">
                {l.label}
              </a>
            </li>)}
        </ul>

        <button className="md:hidden text-paper" onClick={() => setOpen(o => !o)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-153" data-mp="3s049ta54e6ll">
          {open ? <XIcon size={26} data-id="element-154" data-mp="34cw5ovjfh3l5" /> : <MenuIcon size={26} data-id="element-155" data-mp="34de8kb0lig21" />}
        </button>
      </nav>

      {open && <div className="md:hidden bg-ink/98 border-t border-white/10" data-id="element-156" data-mp="39bpl4ti9z4ny">
          <ul className="flex flex-col px-6 py-4" data-id="element-157" data-mp="399uz1bv9p6ia">
            {links.map(l => <li key={l.href} data-id="element-158" data-mp="319glgvk4k5rc">
                <a href={l.href} onClick={() => setOpen(false)} className="block py-3 text-paper/85 hover:text-gold-light tracking-wide" data-id="element-159" data-mp="2wc6lwn30udps">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </div>}
    </header>;
}